import React, { memo } from 'react'
import { Box } from '@mui/material'

import { FORGOT_PASSWORD_URL, LOG_IN_URL } from 'src/constants/navigation'
import { RESET_PASSWORD_PROFILE_DISPATCH } from 'src/store/reducers/auth/resetPassword'
import { ERROR_TEXT } from 'src/constants/messages'
import customConfig from 'customConfig'
import TextLink from 'src/components/shared/text/TextLink'
import CustomForm from 'src/components/shared/inputs/CustomForm'
import CustomTextField from 'src/components/shared/inputs/CustomTextField'
import SubmitButton from 'src/components/shared/button/SubmitButton'
import { FormReturnLink } from 'src/components/shared/auth/form-return-link'
import { FormHead } from 'src/components/shared/auth/form-head'
import PageTitle from 'src/components/shared/pageTitle/PageTitle'

const ResetPassword = ({
  onFormSubmit,
  dispatchAction,
  resetPasswordProfile: { error, newPassword },
  t
}) => {
  const pageTitle = t(customConfig.resetPasswordLabel)

  const tryAgainForgotPassword = (error) => {
    if (error && error === t(ERROR_TEXT.PASSWORD_LINK_EXPIRED)) {
      return (
        <>
          {error}{' '}
          <TextLink
            label={t('reset-password.please-try-again')}
            to={FORGOT_PASSWORD_URL}
            variant='caption'
          />
        </>
      )
    }
    return t(error)
  }

  return (
    <>
      <PageTitle title={pageTitle} />
      <FormHead
        title={t('reset-password.enter-new-password-to-reset')}
        sx={{ textAlign: { xs: 'center', md: 'left' } }}
      />
      <CustomForm onFormSubmit={onFormSubmit}>
        <Box sx={{ gap: 3, display: 'flex', flexDirection: 'column' }}>
          <CustomTextField
            label={t('common.password')}
            eyePassword
            error={tryAgainForgotPassword(
              error[RESET_PASSWORD_PROFILE_DISPATCH.NEW_PASSWORD]
            )}
            value={newPassword}
            onChange={(value) =>
              dispatchAction(
                RESET_PASSWORD_PROFILE_DISPATCH.NEW_PASSWORD,
                value
              )
            }
          />

          <SubmitButton label={pageTitle} />
        </Box>
      </CustomForm>
      <FormReturnLink label={t('common.cancel')} to={LOG_IN_URL} />
    </>
  )
}

export default memo(ResetPassword)
